// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_2whtf","logo":"index_logo_1LS0R","logoAnimate":"index_logoAnimate_14CTX","mainLogo":"index_mainLogo_2TDSw","version":"index_version_10hEs"};